"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Button = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Link = _interopRequireDefault(require("../Link"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

/**
 * The main button component
 * @param {Children}				children    The Buttons Text
 * @param {void}				    onClick	    On click event
 * @param {string}          link 		    Destination if button is an internal link
 * @param {boolean}         external    Indicates an external link
 * @param {buttonColors}    color 	    The color style of the button
 * @param {buttonVariants}  variant     The buttons variant
 * @param {buttonSizes}	    size        The size of the buttton
 * @param {boolean}	        fullWidth   Whether or not to display the button fullwidth
 * @param {string}	        className   Whether or not to display a extra class
 * @param {string}          anchor      A section anchor to navigate to
 * @param {string}          type        A type for the button
 * @param {boolean}         disabled    The button disabled attribute
 * @param {string}          title 		  Title text if button is an internal link
 **/
var Button = function Button(_ref) {
  var _cn;

  var children = _ref.children,
      onClick = _ref.onClick,
      link = _ref.link,
      _ref$external = _ref.external,
      external = _ref$external === void 0 ? false : _ref$external,
      _ref$anchor = _ref.anchor,
      anchor = _ref$anchor === void 0 ? false : _ref$anchor,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'default' : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'raised' : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
      className = _ref.className,
      type = _ref.type,
      htmlType = _ref.htmlType,
      id = _ref.id,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var classes = (0, _classnames.default)(_styleModule.default[variant], _styleModule.default[color], _styleModule.default[size], (_cn = {}, (0, _defineProperty2.default)(_cn, _styleModule.default.fullWidth, fullWidth === true), (0, _defineProperty2.default)(_cn, _styleModule.default['fullWidth-xs'], fullWidth === 'xs'), (0, _defineProperty2.default)(_cn, _styleModule.default['fullWidth-sm'], fullWidth === 'sm'), (0, _defineProperty2.default)(_cn, _styleModule.default['fullWidth-md'], fullWidth === 'md'), (0, _defineProperty2.default)(_cn, _styleModule.default['fullWidth-lg'], fullWidth === 'lg'), (0, _defineProperty2.default)(_cn, _styleModule.default['fullWidth-xl'], fullWidth === 'xl'), (0, _defineProperty2.default)(_cn, className, className), _cn));
  return link || anchor !== false ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default, {
    className: (0, _classnames.default)(_styleModule.default.silentLink, classes),
    to: "".concat(link ? link : '').concat(anchor ? anchor : ''),
    external: external,
    anchor: anchor !== false,
    id: id,
    title: title,
    children: children
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
    id: id,
    className: classes,
    onClick: onClick,
    type: type || htmlType ? type || htmlType : 'button',
    disabled: disabled,
    "aria-label": "button",
    title: title,
    children: children
  });
};

exports.Button = Button;
var _default = Button;
exports.default = _default;